export default {
  root: {
    textTransform: 'none',
    borderRadius: 8,
    fontWeight: 500
  },
  contained: {
    boxShadow: '0 1px 2px rgba(16,24,40,.06), 0 1px 3px rgba(16,24,40,.08)',
    backgroundColor: '#FFFFFF'
  }
};
